import React, {useContext} from 'react'
import './App.css';
import About from './routes/About/About';
import Service from './routes/Service-search/Service';
import Land from './routes/land/Land';
import Services from './routes/services/Service'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Comingsoon from './routes/comingsoon/comingsoon'
import UserRegistration from './routes/signup/User_Registration';
import UserRegistrationStep2 from './routes/signup/User_Registration_Step2';
import UserRegistrationStep3 from './routes/signup/User_Registration_Step3';
import Congratulation from './routes/congratulation/Congratulation';
import Login from './routes/login/login';
import AppHome from "./routes/patientAppRoute/Home/home";
import SubmitChat from "./routes/patientAppRoute/Chat/submitComplaint";
import Payment from "./routes/patientAppRoute/Chat/chatPayment";
import AwaitingMedicalPro from "./routes/patientAppRoute/Chat/awaitngMedicalPro"
import Chat from "./routes/patientAppRoute/Chat/chat";
import ExtendChat from "./routes/patientAppRoute/Chat/extendChat";
import SummaryReady from "./routes/patientAppRoute/Summary/summaryready";
import Profile from "./routes/patientAppRoute/Profile/profile";
import Record from "./routes/patientAppRoute/Record/record"
import Signout from "./routes/signout/signout";
import Help from "./routes/patientAppRoute/Help/help";
import Summary from "./routes/patientAppRoute/Summary/summary";

// import AdminLogin from './admin/routes/login/Login'
// import Dashboard from './admin/routes/dashboard/Dashboard'
// import Dashsearch from './admin/routes/dashboard/Dashsearch'
// import Doctorprofile from './admin/routes/dashboard/Doctorprofile'
// import PendApproval from './admin/routes/pendApprove/PendApprove'
// import Dashlist from './admin/routes/dashboard/Dashlist';
// import AdminSignup from './admin/routes/login/Signup';
// import PaySuccess from './schedule/paySuccess';
// import ScheduleApp from './schedule/ScheduleApp';
// import ScheduleDash from './admin/routes/schedule/Scheduledash'

function App() {
  return (
    <BrowserRouter>
      <Routes>   
      <Route path="/help" element={<Help />} />  
      <Route path="/signout" element={<Signout />} />  
      <Route path="/medical-record" element={<Record />} /> 
      <Route path="/patient-profile" element={<Profile />} /> 
      <Route path="/summary" element={<Summary />} />  
      <Route path="/summary-ready" element={<SummaryReady />} /> 
      <Route path="/extend-chat" element={<ExtendChat />} />
       <Route path="/patient-chat" element={<Chat />} />
      <Route path="/awaiting-medical-pro" element={<AwaitingMedicalPro />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/submit-complaint" element={<SubmitChat />} />
      <Route path='/user-home' element={<AppHome />} />
      <Route path='/login' element={ <Login />}/>
      <Route path='/thank-you' element={ <Congratulation />}/>
      <Route path='/User_SignUp_Step3' element={<UserRegistrationStep3 />} />
      <Route path='/User_SignUp_Step2' element={<UserRegistrationStep2 />} />
    <Route path='/user_signup_step_1' element={<UserRegistration />}/>
      <Route path='*' element={<Comingsoon />} />
        <Route path='/services-result' element={<Service />} />
        <Route path='/services' element={<Services />} />
        <Route path='/about' element={<About />} />
        <Route path='/' element={<Land />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;